module.exports = __webpack_public_path__ + "img/product17-dianzi.87dcd4cc.svg";